import { Box, Button, useTheme } from "@mui/material";
import { useState } from "react";
import { useDeployments } from "../hooks/useDeployments";
import { Deployment } from "../models/types";
import { EmptyTable } from "../molecules/EmptyTable";
import { APITable } from "../organisms/APITable";
import { ShowInstructionsModal } from "../organisms/modals/ShowInstructionsModal";
import { DeploymentDetailsModal } from "../organisms/modals/workflows/DeploymentDetailsModal";
import {
  deploymentsListColumnsVisibility,
  deploymentsListFilterOptions,
} from "../utilities/columns-visibility/DeploymentListColumnsVisibility";

const DeploymentListPage = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [deploymentId, setDeploymentId] = useState<null | string>(null);
  const theme = useTheme();
  return (
    <Box paddingBottom="60px">
      <ShowInstructionsModal type="Deployment" open={open} onClose={() => setOpen(false)} />
      {deploymentId && (
        <DeploymentDetailsModal
          open={!!deploymentId}
          onClose={() => setDeploymentId(null)}
          deploymentId={deploymentId}
        />
      )}
      <APITable
        useGetData={useDeployments}
        queryParams={{}}
        columnsVisibility={deploymentsListColumnsVisibility(false, theme)}
        filterOptions={deploymentsListFilterOptions}
        rowOnClick={(row: Deployment) => {
          setDeploymentId(row.id);
        }}
        secondComponent={
          <Box display="flex" flexGrow={1} gap="10px" alignItems="center" justifyContent="flex-end">
            <Button onClick={() => setOpen(true)} variant="contained">
              Create
            </Button>
          </Box>
        }
        emptyTableComponent={
          <EmptyTable
            variant="workflow"
            label="Deployments"
            description="You don't have any deployments yet"
          />
        }
        tableSize="big"
        displayTags={false}
        smallEmptyHeight={false}
        bigFixedHeight={`calc(80vh - 56px)`}
      />
    </Box>
  );
};

export default DeploymentListPage;
